import Vue from 'vue'
import { Toast, Icon, CountDown } from 'vant'
import 'vant/lib/index.css';

Vue.prototype.$toast = Toast

Vue.use(Icon)
Vue.use(CountDown)
